import type { TourKey } from '@osteopro/shared';

/**
 * Ce qui ne doit arriver qu'une fois par session d'onglet : la redirection vers l'assistant, et le
 * lancement automatique d'une visite. Rien de personnel — un identifiant de cabinet et des clés
 * fixes. La mémoire de l'onglet survit au rechargement ; à défaut de stockage, celle du module.
 */

const REDIRECT_KEY = 'osteopro.onboarding.redirected';
const memory = new Set<string>();

function remembered(key: string): boolean {
  if (memory.has(key)) return true;
  try {
    return globalThis.sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function remember(key: string): void {
  memory.add(key);
  try {
    globalThis.sessionStorage.setItem(key, '1');
  } catch {
    // Stockage indisponible : la mémoire du module suffit pour cette session.
  }
}

/** Vrai la première fois seulement, pour ce cabinet et cet onglet. */
export function claimWizardRedirect(organizationId: string): boolean {
  const key = `${REDIRECT_KEY}.${organizationId}`;
  if (remembered(key)) return false;
  remember(key);
  return true;
}

const autoStartedTours = new Set<TourKey>();

/** Une visite ne se relance pas d'elle-même dans la session, même passée sans réponse du serveur. */
export function claimAutoTour(tour: TourKey): boolean {
  if (autoStartedTours.has(tour)) return false;
  autoStartedTours.add(tour);
  return true;
}

export function resetSessionMemoryForTests(): void {
  memory.clear();
  autoStartedTours.clear();
  try {
    for (const key of Object.keys(globalThis.sessionStorage)) {
      if (key.startsWith(REDIRECT_KEY)) globalThis.sessionStorage.removeItem(key);
    }
  } catch {
    // Rien à nettoyer.
  }
}
